// Tests that the string starts with '+' & has min length
const validatePhone = (phone) => (/^\+(?:[0-9]?){6,14}[0-9]$/.test(phone) && phone.length >= 7)
export default validatePhone
